module.exports = __webpack_public_path__ + "static/media/googleCodeIn.3b59be8d.png";